<script>
import ImageProduct from "@/components/products/viewProduct/ImageProduct.vue";

export default {
  name: 'ProductListOrderDetail',
  components: {ImageProduct},
  props: {
    productCart: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="space-y-4 p-6">
    <div class="flex items-center gap-6">
      <a :href="'/boutique/' + productCart.products.id" target="_blank" class="h-14 w-14 shrink-0">
        <image-product :product="productCart.products" />
      </a>

      <a :href="'/boutique/' + productCart.products.id" target="_blank" class="min-w-0 flex-1 font-medium text-gray-900 hover:underline dark:text-white">
        {{ productCart.products.title }}
      </a>
    </div>

    <div class="flex items-center justify-between gap-4">
      <p class="text-sm font-normal text-gray-500 dark:text-gray-400">
        <span class="font-medium text-gray-900 dark:text-white">Numéro produit:</span> BJ8364850
      </p>
      <div class="flex items-center justify-end gap-4">
        <p class="text-base font-normal text-gray-900 dark:text-white">
          x{{ productCart.quantity }}
        </p>

        <p class="text-xl font-bold leading-tight text-gray-900 dark:text-white">
          {{ productCart.products.price * productCart.quantity }}€
        </p>
      </div>
    </div>
  </div>
</template>
